import React from 'react';
import { UserTooltip } from 'motion-components';
import { LegacyTooltip } from './index';
import { AuditTrailTooltip } from './audit-trail-tooltip';

type Props = {
  data: any;
  showLegacy?: boolean;
  /** Όνομα πίνακα στο audit_trail· αν δοθεί, εμφανίζεται το εικονίδιο ιστορικού */
  auditTable?: string;
};

export const RowFieldTooltips = ({ data, showLegacy = true, auditTable }: Props) => {
  return (
    <div className="d-flex flex-row-reverse mt-3 mb-0">
      {data && <UserTooltip data={data} />}
      {data && auditTable && (
        <>
          <span className="mx-1"></span>
          <AuditTrailTooltip data={data} auditTable={auditTable} />
        </>
      )}
      <span className="mx-1"></span>
      {data && showLegacy && <LegacyTooltip data={data} />}
    </div>
  );
};

